"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeFetchInitialStateForLabels = void 0;
const tslib_1 = require("tslib");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const Labels_1 = require("./Labels");
function makeFetchInitialStateForLabels(params) {
    const { transform, category, siteLuid } = params;
    const { makeJsonRestApiRequest } = (0, vizportalclient_common_components_1.restApiService)({ siteLuid });
    return (bodyProps, dialogState) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            const { contentItem } = bodyProps;
            const result = yield (0, Labels_1.getLabels)({ transform, category, contentItems: [contentItem], makeJsonRestApiRequest });
            const labels = (_a = result
                .get({
                contentId: contentItem.contentId,
                contentType: contentItem.contentType.toLowerCase(),
            })) === null || _a === void 0 ? void 0 : _a.filter((label) => {
                return label.labelValue !== 'EXTRACT_REFRESH_FAILURE' && label.labelValue !== 'FLOW_RUN_FAILURE';
            });
            if (!labels) {
                return dialogState;
            }
            const first = labels[0];
            if (!first) {
                return dialogState;
            }
            return first;
        }
        catch (_b) {
            return dialogState;
        }
    });
}
exports.makeFetchInitialStateForLabels = makeFetchInitialStateForLabels;
//# sourceMappingURL=useLabels.js.map